<template>
    <v-app>
        <router-view/>
    </v-app>
</template>

<script>
    export default {
        name: 'app',
    }
</script>

<style>
    :root {
        --background-color: rgb(84, 84, 84);
        --divider-size: 0.15vw;
        --primary-color: #78BE13;
    }

    a.v-btn.primary {
        background: var(--primary-color) !important;
        border-radius: 25px;
        padding-left: 1.5rem;
        padding-right: 1.5rem;
    }

    button {
        outline: none !important;
    }

    @font-face {
        font-family: "Roadgeek";
        src: local("Roadgeek"),
        url(./fonts/roadgeek.otf) format("opentype");
    }

    html {
        background-color: var(--background-color);
        overflow: hidden !important; /* no scrollbars on displays! */
    }

    .v-application {
        background-color: var(--background-color) !important;
        font-family: 'Roadgeek' !important;
        color: white !important;
    }

    .announcement {
        background: black;
        overflow: hidden;
        position: relative;
        padding: 1vw 6%;
        --base-color: white; /* default color for emphasized texts, icons, left stripe etc. */
    }

    .announcement.left-stripe {
        --left-stripe-width: 2.25vw;
        border-left: var(--left-stripe-width) solid var(--base-color);
    }

    .announcement.single.left-stripe {
        --left-stripe-width: 3.5vw;
        border-left-width: var(--left-stripe-width); /* a larger stripe if announcements are not diaplyed in parallel */
    }

    .bottom-divider {
        margin-bottom: var(--divider-size);
    }
</style>
